module.exports = __webpack_public_path__ + "img/report_img_202209.0b7a0f3a.png";